import React, { FC, useState } from 'react'
import { useTheme } from 'react-jss'
import { useDefaultValue } from '@cse/ui'

import { LightTheme } from '../../theme'
import { Icon, Row, Text } from '../../components'

import { CheckboxProps } from './checkbox.types'
import { useStyle } from './checkbox.styles'

export const Checkbox: FC<CheckboxProps> = ({
  className = '',
  disabled = false,
  defaultValue,
  value: outerValue,
  preset = 'body',
  tx,
  text = '',
  color,
  description = '',
  onChange,
  onBlur
}) => {
  const theme: LightTheme = useTheme()
  const [value, changeValue] = useState<boolean | undefined>(defaultValue)
  const Value = useDefaultValue<boolean | undefined>(value, outerValue)
  const classes = useStyle({ theme, description })

  const icon = Value ? 'CheckboxActive' : 'CheckboxInactive'
  const textColor = color ? color : 'inactive'

  const handleOnChange = () => {
    if (!disabled) {
      const newStatus = !Value
      changeValue(newStatus)

      if (onChange) {
        onChange(newStatus)
      }
    }
  }

  const handleOnBlur = () => {
    if (onBlur) {
      onBlur(Value)
    }
  }

  return (
    <Row
      className={className}
      justifyContent="flex-start"
      onClick={handleOnChange}
    >
      <Icon
        name={icon}
        fill={theme.colors.darkBlue}
        onMouseLeave={handleOnBlur}
      />
      {text && (
        <Text
          className={classes.text}
          text={text}
          tx={tx}
          preset={preset}
          color={textColor}
        />
      )}
    </Row>
  )
}
